import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { adminLogin, adminMe, adminLogout } from "@/lib/api";

const AdminAuthContext = createContext(null);

export function AdminAuthProvider({ children }) {
  const [status, setStatus] = useState("loading"); // loading | authed | guest
  const [user, setUser] = useState(null);

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const me = await adminMe();
        if (active) {
          setUser(me);
          setStatus("authed");
        }
      } catch {
        if (active) {
          setUser(null);
          setStatus("guest");
        }
      }
    })();
    return () => {
      active = false;
    };
  }, []);

  const login = useCallback(async (username, password) => {
    const u = await adminLogin(username, password);
    setUser(u);
    setStatus("authed");
    return u;
  }, []);

  const logout = useCallback(() => {
    adminLogout();
    setUser(null);
    setStatus("guest");
  }, []);

  return (
    <AdminAuthContext.Provider value={{ status, user, login, logout }}>
      {children}
    </AdminAuthContext.Provider>
  );
}

export function useAdminAuth() {
  const ctx = useContext(AdminAuthContext);
  if (!ctx) throw new Error("useAdminAuth must be used within AdminAuthProvider");
  return ctx;
}
